// extracted by mini-css-extract-plugin
export default {"root":"_2qGJU","icon":"_3ZUxu","title":"_279zb","subtitle":"_1uSwq"};